<template>
  <div class="newsletter">
    <div class="icon-container">
      <img src="@/assets/icons/newsletter_icon_light.svg" class="icon filter-to-primary img-fluid">
    </div>
    <div class="link-container bg-light-grey">
      <a href="https://mailchi.mp/nissens/join-nissens-newsletter" target="_blank" class="text-sm">
        {{ $t('common.newsletterJoin') }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Newsletter',
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';
.newsletter {
  position: relative;
  padding: 9px 15px;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  transition: background .2s ease-in-out;
  &:hover {
    background: $light-grey;
    .link-container {
      visibility: visible;
      opacity: 1;
      a {
        transform: translateX(0);
      }
    }
  }
  .icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    .icon {
      max-width: 25px;
      width: 100%;
      @include media-breakpoint-down(sm) {
        max-width: 20px;
      }
    }
  }
  .link-container {
    position: absolute;
    width: max-content;
    top: 0;
    right: calc(-100% + 110px);
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 15px;
    padding-right: 3px;
    border-radius: 5px 0 0 5px;
    visibility: hidden;
    opacity: 0;
    transition: all .2s ease-in-out;
    a {
      transform: translateX(15px);
      transition: all .2s ease-in-out;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  @include media-breakpoint-down(sm) {
    border-radius: 5px 5px 0 0;
    .link-container {
      max-width: 50vw;
      top: 33px;
      right: 0;
      height: auto;
      padding: 10px 15px;
      border-radius: 5px 0 5px 5px;
      a {
        transform: translateY(5px);
      }
    }
  }
}
</style>
